import React from 'react'
import LazyImage from '../lib/LazyImage'
import Carousel from '../lib/Carousel'
import Link from '../lib/Link'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {addScrollListener,removeScrollListener} from '../lib/ScrollObserver'

class CFBg extends React.Component {
	state = {
		visible: false,
		h: 400,
		current: 0,
		z: 0
	}
	componentWillMount() {
		const {bg} = this.props
		try {
			if ('IntersectionObserver' in window) {
			    this.observer = new IntersectionObserver(this.onVisible, {
  				root: null,
  				rootMargin: '0px',
  				threshold: 0
		    	})
			}
		} catch(e) {
		    //eslint-disable-next-line
		    Bugsnag.notifyException(e)
		    console.log(e)
		}
		if(!bg || bg.length===0) return
    	
    	this.setState({h: window.innerWidth * bg[0].h / bg[0].w})
	}
	componentDidMount() {
		this.c = setInterval(() => this.setImage(), 7500)
		this.scroll = addScrollListener(this.onScroll)
	}
	componentWillUnmount = () => {
		clearInterval(this.c)
        removeScrollListener(this.scroll)
        if(this.observer && this.img) this.observer.unobserve(this.img)
	}
	setImage = () => {
		const {visible} = this.state
		const n = this.props.bg.length

		if (!visible) return
		this.setState({current: Math.floor(Math.random() * n)})
	}
	onScroll = (status, scrollbar) => {
		const {visible, h, z} = this.state
		if (!visible) return
		const offset = status.offset.y
		const newZ = Math.floor( ( offset / h ) * 500)
		if (newZ!==z) this.setState({z: newZ})
	}
	onVisible = (entries, observer) => {
		const {visible} = this.state
		
		if (visible!==entries[0].isIntersecting) this.setState({visible: entries[0].isIntersecting})
	}
	setRef = ref => {
		if(!ref) return
		
		if(this.observer && this.img) this.observer.unobserve(this.img)
		this.img = ref.img
		if(this.observer) this.observer.observe(this.img)
	}
	render = () => {
		const {current, z} = this.state
		const {bg, onAspectChange, proportional, container, config, imageStyle} = this.props
		
		return (
			<ReactCSSTransitionGroup
        		transitionName='bg'
        		transitionEnterTimeout={2000}
        		transitionLeaveTimeout={2000}
        		transitionAppear={true}
      			transitionAppearTimeout={2000}>
      			<LazyImage ref={this.setRef} key={bg[current].url} 
      				className='bg' src={bg[current]} alt='' bg={true} 
      				imageStyle={imageStyle}
      				style={{transform: `perspective(1000px) translateZ(${z}px)`}}
					proportional={proportional} onAspectChange={onAspectChange}
					container={container} screen={config.screen}/>
			</ReactCSSTransitionGroup>
		)
	}
}

class SimpleBg extends React.Component {
	state = {
		visible: false,
		h: 400,
		z: 0
	}
	componentWillMount() {
		const {bg} = this.props
		if(!bg || bg.length===0) return
    	
    	this.setState({h: window.innerWidth * bg[0].a / 100})
	}
	componentDidMount() {
		this.scroll = addScrollListener(this.onScroll)
		try {
		    this.observer = new IntersectionObserver(this.onVisible, {
  			root: null,
  			rootMargin: '0px',
  			threshold: 0
		    })
		    this.observer.observe(this.ref.img)
		} catch(e) {
                    //eslint-disable-next-line
                    Bugsnag.notifyException(e)
                    console.log(e)
                }
	}
	componentWillUnmount() {
        removeScrollListener(this.scroll)
        if(this.observer && this.ref) this.observer.unobserve(this.ref.img)
	}
	onVisible = (entries, observer) => {
		const {visible} = this.state
		
		if (visible!==entries[0].isIntersecting) this.setState({visible: entries[0].isIntersecting})
	}
	onScroll = (status, scrollbar) => {
		const {visible, h, z} = this.state
		if (!visible) return
		const offset = status.offset.y
		const newZ = Math.floor( ( offset / h ) * 500)
		if (newZ!==z) this.setState({z: newZ})
		
	}
	setRef = ref => {
		this.ref = ref
	}
	render() {
		const {bg, onAspectChange, proportional, container, config, imageStyle} = this.props
		const {z} = this.state
		if(!bg || bg.length===0) return null
		
		if (config.transitionBg) {
			return (
				<ReactCSSTransitionGroup
        		transitionName='bg'
        		transitionEnterTimeout={500}
        		transitionLeaveTimeout={300}
        		transitionAppear={true}
      			transitionAppearTimeout={500}>
      			<LazyImage ref={this.setRef} key={bg[0].url} className='bg' src={bg[0]} alt='' bg={true} 
      				imageStyle={imageStyle} style={{transform: `perspective(1000px) translateZ(${z}px)`}}
					proportional={proportional} onAspectChange={onAspectChange}
					container={container} screen={config.screen}/>
			</ReactCSSTransitionGroup>
			)
		}
		return (
			<LazyImage className='bg' src={bg[0]} alt='' bg={true} 
				proportional={proportional} onAspectChange={onAspectChange}
				container={container} screen={config.screen}/>
		)
	}
}

const Bg = props => {
	if(!props.bg || props.bg.length===0) return null
	if (props.bg.length>1) return <CFBg {...props}/>
	return <SimpleBg {...props}/>
}

const Img = ({src, classes, style, screen, imageStyle}) => {
	if(!src || src.length===0) return null
	const imgClasses = (classes || '') + ' img '
	return (
		<div className={imgClasses} style={style}>
			{(src.length === 1)
				?<LazyImage className='image' src={src[0]} imageStyle={imageStyle} alt='' />
				:<Carousel items={src} proportional={true} imageStyle={imageStyle || 'gallery-full'} current={0} screen={screen}/>
			}
		</div>
	)
}
//				?<LazyImage className='image' src={src[0]} imageStyle={imageStyle || 'gallery-full'} alt='' bg={true} proportional={true} screen={screen}/>

const FaIcon = ({icon}) => {
	if(!icon) return null
	
	return (
		<div className='faicon'><i className={`fa fa-${icon}`}></i></div>
	)
}

const Action = ({call, action}) => {
	//const lcall = l(call)
	//const laction = l(action)
	if(!call || !action) return null
	return <Link className='button large' to={action}>{call}</Link>
}
export {Img, Bg, FaIcon, Action}
/*
onAspectChange={aspect => this.onAspectChange(aspect)}

	onAspectChange = aspect => {
		if (this.props.block.bg && this.props.block.bg.length>0) {
			const el = document.querySelector(`#block-${this.props.block.uuid}`)
			el.style.paddingBottom = aspect
		} else {
			const el = document.querySelector(`#block-${this.props.block.uuid} > .content`)
			el.style.paddingBottom = aspect
		}
	}
*/


// WEBPACK FOOTER //
// ./src/fm/field/Fields.js